// Google Analytics

// Shared form navigation
export const NEXT_BUTTON_EVENT= "next_button";
export const PREVIOUS_BUTTON_EVENT = "previous_button";
export const FINISH_LATER_EVENT = "finish_later_button";
export const SIGN_OUT_EVENT = "sign_out_button";
export const SEARCH_ADDRESS_COUNT_TRACKING_FIELD = "searchAddress_count";
export const MAP_PINDROP_TRACKING_FIELD = "mapPindrop";
export const SIGN_IN_BUTTON_EVENT = "sign_in_button";
export const SIGN_IN_BUTTON_PARAM_KEY = "sign_in_button_step";
export const ADD_FAMILY_MEMBER_BUTTON_TRACKING_FIELD = "add_family_member_button_clicked";
export const ADD_ANOTHER_FAMILY_MEMBER_BUTTON_TRACKING_FIELD = "add_another_family_member_button_clicked";
export const SIGN_OUT_PARAM_KEY = "sign_out_step";